import api from "utils/helper/api";
import { FOOTER, MENU_API, NAVBAR_ACTIVE, SET_LANGUAGE } from "./globalTypes";

export const setLanguage = (value) => {
    return {
        type: SET_LANGUAGE,
        payload: {
            value
        }
    };
};

export const setNavbarActive = (value) => {
    return {
        type: NAVBAR_ACTIVE,
        payload: {
            value
        }
    };
};

export const setMenuApi = (value) => {
    return {
        type: MENU_API,
        payload: {
            value
        }
    };
};

export const setFooter = (payload) => {
    return {
        type: FOOTER,
        payload
    };
};


export const getMenuApi = () => async (dispatch, getState) => {
    try {
        const { data } = await api.apiGet(`/Menu`);
        const menuData = data?.Data ?? []; // Default to empty array if null or undefined

        dispatch(setMenuApi(menuData.map((val) => {
            return {
                title: val?.nama,
                path: val?.halaman?.startsWith("pages") ? val.halaman.replace("pages", "") : val.halaman,
            };
        })));
    } catch (error) {
        console.error("Error fetching menu:", error); // Better error logging
        return Promise.reject(error);
    }
};


export const getFooter = () => async (dispatch, getState) => {
    try {
        const { data } = await api.apiGet(`/Footer`)
        if (data?.Data) {
            const { sosmed, general } = data?.Data
            await dispatch(setFooter({
                key: 'sosmed',
                value: sosmed
            }));
            await dispatch(setFooter({
                key: 'general',
                value: general
            }));
        }
    } catch (error) {
        return Promise.reject(error);
    }
};